import fetchCurrentOrder from '../../currentOrder/actions/fetchCurrentOrder';
import selectCurrentOrder from '../../currentOrder/selectors/selectCurrentOrder';
import fetchCart from './fetchCart';

function fetchCheckoutData() {
    return async (dispatch, getState) => {
        await dispatch(fetchCurrentOrder());
        const order = selectCurrentOrder(getState());
        if (order !== null) {
            const { token } = order;
            dispatch(fetchCart({ token }));
        }
    };
}

export default fetchCheckoutData;
